'use strict'
export default {
  getCHNCon:function(){
    let result=[
      {title:'会员类型',list:[ {mapKey:'key1',name:'会员类型',queryConditionType:5,table:'yxs_memberaccount',inputValue:null,_key:'UserType',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
          options:[{value:1,label:'电商卖家',checked:false,disable:false},{value:2,label:'微商卖家',checked:false,disable:false},{value:4,label:'直播卖家',checked:false,disable:false},{value:8,label:'批发客户',checked:false,disable:false},{value:16,label:'供应商',checked:false,disable:false}
            ,{value:32,label:'个人卖家',checked:false,disable:false},{value:64,label:'独家代理',checked:false,disable:false},{value:1024,label:'其他',checked:false,disable:false}]}
          ,{mapKey:'key2',name:'会员等级',queryConditionType:6,table:'yxs_memberaccount',inputValue:null,_key:'UserGroup',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[]}
          ,{mapKey:'key3', name:'VIP等级',queryConditionType:6, table:'chn_userData', inputValue:null, _key:'VipLevel',type:2, needAvgDay:0,
            leftRange:null, rightRange:null, avgDayCondition:null,singleValue:null, singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[]}
          ,{mapKey:'key4',name:'电商平台',queryConditionType:5,table:'chn_userData',inputValue:null,_key:'ShopType',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:0,label:'未授权过平台',checked:false,disable:false},{value:1,label:'天猫',checked:false,disable:false},{value:2,label:'淘宝',checked:false,disable:false},{value:4,label:'阿里巴巴',checked:false,disable:false},{value:8,label:'京东',checked:false,disable:false},{value:16,label:'蘑菇街',checked:false,disable:false}
              ,{value:32,label:'美丽说',checked:false,disable:false},{value:64,label:'微店',checked:false,disable:false},{value:128,label:'有赞',checked:false,disable:false},{value:256,label:'拼多多',checked:false,disable:false},{value:512,label:'分销平台',checked:false,disable:false}
              ,{value:1024,label:'抖音小店',checked:false,disable:false},{value:4096,label:'微信小店',checked:false,disable:false}
              ,{value:8192,label:'快手小店',checked:false,disable:false}]}
          ]},
      {title:'注册维度',list:[{mapKey:'key5',name:'注册后第几天',queryConditionType:2,table:'yxs_memberaccount',inputValue:null,_key:'RegisterDate',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天'}
          ,{mapKey:'key6',name:'注册当天是否下单',queryConditionType:4,table:'chn_userData',inputValue:null,_key:'orderNumFirstDay',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'有',checked:false,disable:false},{value:0,label:'无',checked:false,disable:false}]}
          ]},
      {title:'登录维度',list:[{mapKey:'key7',name:'常用终端',queryConditionType:5,table:'chn_userData',inputValue:null,_key:'lastUsedDevice',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
          options:[{value:1,label:'PC',checked:false,disable:false},{value:8,label:'小程序',checked:false,disable:false},{value:32,label:'IOS',checked:false,disable:false},{value:64,label:'安卓',checked:false,disable:false},{value:4,label:'H5',checked:false,disable:false}]}
          ,{mapKey:'key8',name:'是否本月月活用户',queryConditionType:9,table:'chn_userData',inputValue:null,_key:'lastLiveTime',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:30,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'是',checked:false,disable:false},{value:0,label:'否',checked:false,disable:false}]}
          ,{mapKey:'key9',name:'最后登录距今多少天',queryConditionType:2,table:'yxs_memberaccount',inputValue:null,_key:'LastLoginDate',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天',
            options:[{value:1,label:'是',checked:false,disable:false},{value:2,label:'否',checked:false,disable:false}]}
          ,{mapKey:'key10',name:'日均打开次数',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'openCount',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:1,unit:'次'}
          ,{mapKey:'key11',name:'日均在线时长',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'liveTime',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:1,unit:'分钟',minuteToHour:60}
          ,{mapKey:'key12',name:'累积在线时长',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'liveTime',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'小时'}
          ]}
      ,{title:'下单维度',list:[{mapKey:'key13',name:'最后下单距今多少天',queryConditionType:2,table:'chn_userOrder',inputValue:null,_key:'lastOrderDate',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天'}
          ,{mapKey:'key14',name:'最后付款距今多少天',queryConditionType:2,table:'chn_userOrder',inputValue:null,_key:'lastPayTime',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天'}
          ,{mapKey:'key15',name:'累积付款订单数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'payCountTotal',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'笔'}
          ,{mapKey:'key16',name:'日均付款订单数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'avgPayCount',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'笔'}
          ,{mapKey:'key17',name:'近3个月月均付款订单数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'avgPayCount3Month',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'笔'}
          ,{mapKey:'key18',name:'货捕头订单退货率',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'returnRate',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:1,unit:'%',useSelf:true,minuteToHour:100}
          ,{mapKey:'key19',name:'三方日均付款订单数',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'taobaoOrder',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:1,unit:'笔'}
          ,{mapKey:'key20',name:'客单价',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'atv',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'元'}
          ,{mapKey:'key21',name:'客单件数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'atn',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'件'}
          ,{mapKey:'key22',name:'是否设置寄件信息',queryConditionType:3,table:'chn_userOrder',inputValue:null,_key:'isSetDeliveryInfo',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'有',checked:false,disable:false},{value:0,label:'无',checked:false,disable:false}]}
          ,{mapKey:'key23',name:'近3个月是否加购过小礼品',queryConditionType:4,table:'chn_userOrder',inputValue:null,_key:'addGiftCount3Month',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'有',checked:false,disable:false},{value:0,label:'无',checked:false,disable:false}]}
          ,{mapKey:'key25',name:'近3个月下单品类',queryConditionType:8,table:'chn_userOrder',inputValue:null,
            _key:'month3Cat',type:5,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'第一',checked:false,disable:false,field:'no1Cat3Month'},{field:'no2Cat3Month',value:2,label:'第二',checked:false,disable:false},{field:'no3Cat3Month',value:3,label:'第三',checked:false,disable:false}],
            options2:[{value:150,label:'女装',checked:false,disable:false},{value:151,label:'男装',checked:false,disable:false},{value:152,label:'童装',checked:false,disable:false}]}
          ,{mapKey:'key26',name:'累计收货地址数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'addressCount',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key27',name:'礼品单最后付款距今多少天',queryConditionType:2,table:'chn_userOrder',inputValue:null,_key:'giftLastPayTime',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天'}
          ,{mapKey:'key28',name:'礼品单累计付款订单数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'giftPayCountTotal',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'笔'}
          ,{mapKey:'key29',name:'礼品单日均付款订单数',queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'giftPayCount',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:1,unit:'笔'}]}
      ,{title:'订单服务维度',list:[
          {mapKey:'key24',name:'近3个月高级质检服务',queryConditionType:4,table:'chn_userOrder',inputValue:null,_key:'seniorCheckCount3Month',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'有',checked:false,disable:false},{value:0,label:'无',checked:false,disable:false}]}
          ,{mapKey:'key44',name:'近3个月外包装服务',queryConditionType:7,table:'chn_userOrder',inputValue:null,_key:'outerPack3Month',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:0,label:'未购买商品服务',checked:false,disable:false},{value:5,label:'气泡袋',checked:false,disable:false},{value:9,label:'飞机盒',checked:false,disable:false},{value:10,label:'气泡袋+飞机盒',checked:false,disable:false}]}
          ,{mapKey:'key45',name:'近3个月内包装服务',queryConditionType:7,table:'chn_userOrder',inputValue:null,_key:'innerPack3Month',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:0,label:'未购买商品服务',checked:false,disable:false},{value:8,label:'磨砂袋',checked:false,disable:false}]}
              ,{mapKey:'key46',name:'近3个月换吊牌服务',queryConditionType:4,table:'chn_userOrder',inputValue:null,_key:'hangTagCount3Month',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
                options:[{value:1,label:'有',checked:false,disable:false},{value:0,label:'无',checked:false,disable:false}]}
              ,{mapKey:'key47',name:'近3个月好评卡服务',queryConditionType:4,table:'chn_userOrder',inputValue:null,_key:'cardCount3Month',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
                options:[{value:1,label:'有',checked:false,disable:false},{value:0,label:'无',checked:false,disable:false}]}
            ]}
          ,{title:'商品维度',list:[  {mapKey:'key30',name:'一键上传成功数',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'oneKeySuccess',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key31',name:'一键上传失败数',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'oneKeyFail',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key32',name:'数据包下载量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'packDown',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key33',name:'图片包下载量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'picDown',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key34',name:'精修大图下载量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'nicePicDown',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key35',name:'商品外链工具生成量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'linkNum',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key36',name:'微商九宫格下载量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'wechatShare',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key37',name:'商品收藏量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'proCollection',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key38',name:'商品浏览量',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'proVisit',_key2:'Day',type:4,needAvgDay:1,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'个'}
          ,{mapKey:'key50',name:'最后收藏商品超过多少天未下单',queryConditionType:2,table:'chn_userData',inputValue:null,_key:'lastCollectionDate',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天'}
          ,{mapKey:'key51',name:'最后加购商品超过多少天未下单',queryConditionType:2,table:'chn_userData',inputValue:null,_key:'lastCartDate',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'天'}
          ]}
      ,{title:'其他维度',list:[ {mapKey:'key39',name:'累计使用优惠券比例（已用/全部券）',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'couponUsedRate',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'%',minuteToHour:100}
      ,{mapKey:'key40',name:'近7天有提现动作',queryConditionType:9,table:'chn_userData',inputValue:null,_key:'lastCashTime',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:7,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
          options:[{value:1,label:'是',checked:false,disable:false},{value:0,label:'否',checked:false,disable:false}]}
          ,{mapKey:'key41',name:'加过企业微信',queryConditionType:3,table:'chn_userData',inputValue:null,_key:'hasHbtWechat',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:7,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'是',checked:false,disable:false},{value:0,label:'否',checked:false,disable:false}]}
          ,{mapKey:'key42',name:'是否关注公众号',queryConditionType:3,table:'chn_userData',inputValue:null,_key:'followHbtWechat',type:1,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:7,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'是',checked:false,disable:false},{value:0,label:'否',checked:false,disable:false}]}
          ,{mapKey:'key43',name:'VIP等级历史最高',queryConditionType:1,table:'chn_userData',inputValue:null,_key:'vipRecord',_key2:'Day',type:4,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null}]}

          ]



    return result;


  },
  getCHNConRealTime:function(){
    let result=[
      {title:'会员类型',list:[
        {mapKey:'key1',name:'会员类型',startTime:null,endTime:null,fastSelect:false,queryConditionType:5,table:'yxs_memberaccount',inputValue:null,_key:'UserType',type:2,needAvgDay:0,leftRange:null,
          rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
          options:[{value:1,label:'电商卖家',checked:false,disable:false},{value:2,label:'微商卖家',checked:false,disable:false},{value:4,label:'直播卖家',checked:false,disable:false},{value:8,label:'批发客户',checked:false,disable:false},{value:16,label:'供应商',checked:false,disable:false}
            ,{value:32,label:'个人卖家',checked:false,disable:false},{value:64,label:'独家代理',checked:false,disable:false},{value:1024,label:'其他',checked:false,disable:false}]
        }
          ,{mapKey:'key2',name:'会员等级',startTime:null,endTime:null,fastSelect:false,queryConditionType:6,table:'yxs_memberaccount',inputValue:null,_key:'UserGroup',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[]}
          ,{mapKey:'key3', name:'VIP等级',startTime:null,endTime:null,fastSelect:false,queryConditionType:6, table:'chn_userData', inputValue:null, _key:'VipLevel',type:2, needAvgDay:0,
            leftRange:null, rightRange:null, avgDayCondition:null,singleValue:null, singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[]}
          ,{mapKey:'key4',name:'电商平台',startTime:null,endTime:null,fastSelect:false,queryConditionType:5,table:'chn_userData',inputValue:null,_key:'ShopType',type:2,needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:0,label:'未授权过平台',checked:false,disable:false},{value:1,label:'天猫',checked:false,disable:false},{value:2,label:'淘宝',checked:false,disable:false},{value:4,label:'阿里巴巴',checked:false,disable:false},{value:8,label:'京东',checked:false,disable:false},{value:16,label:'蘑菇街',checked:false,disable:false}
              ,{value:32,label:'美丽说',checked:false,disable:false},{value:64,label:'微店',checked:false,disable:false},{value:128,label:'有赞',checked:false,disable:false},{value:256,label:'拼多多',checked:false,disable:false},{value:512,label:'分销平台',checked:false,disable:false}
              ,{value:1024,label:'抖音小店',checked:false,disable:false},{value:4096,label:'微信小店',checked:false,disable:false}
              ,{value:8192,label:'快手小店',checked:false,disable:false}]}
        ]},
      {title:'注册维度',list:[
        {mapKey:'key5',name:'注册时间范围',fastSelect:false,startTime:null,endTime:null,queryConditionType:10,table:'yxs_memberaccount',inputValue:null,_key:'RegisterDate',type:6,needAvgDay:0,
          leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0
          , options:[{value:1,label:'查询近90天',checked:false,disable:false}]}]},
      {title:'登录维度',list:[
        {mapKey:'key6',name:'登陆时间范围',fastSelect:false,startTime:null,endTime:null,queryConditionType:10,table:'yxs_memberaccount',inputValue:null,_key:'LastLoginDate',type:6,
          needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0
          , options:[{value:1,label:'查询近90天',checked:false,disable:false}]}
         ,{mapKey:'key7',name:'当天打开次数',startTime:null,endTime:null,fastSelect:false,queryConditionType:1,table:'chn_userData',inputValue:null,_key:'openCount1Day',type:4,needAvgDay:0,leftRange:null,
            rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'次'}
        ,{mapKey:'key8',name:'当天在线时长',startTime:null,endTime:null,fastSelect:false,queryConditionType:1,table:'chn_userData',inputValue:null,_key:'liveTime1Day',type:4,needAvgDay:0,leftRange:null,
            rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'分钟',minuteToHour:60}]}
      ,{title:'下单维度',list:[
      {mapKey:'key9',name:'最后下单时间范围',fastSelect:false,startTime:null,endTime:null,queryConditionType:10,table:'chn_userOrder',inputValue:null,_key:'LastOrderDate',type:6,
        needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:null,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0
        , options:[{value:1,label:'查询近90天',checked:false,disable:false}]}
          ,{mapKey:'key10',name:'当天有无下单',startTime:null,endTime:null,fastSelect:false,queryConditionType:9,table:'chn_userOrder',inputValue:null,_key:'LastOrderDate',type:1,needAvgDay:0,
            leftRange:null,rightRange:null,avgDayCondition:1,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,
            options:[{value:1,label:'是',checked:false,disable:false},{value:0,label:'否',checked:false,disable:false}]}
      ,{mapKey:'key11',name:'单笔金额达到过多少钱',startTime:null,endTime:null,fastSelect:false,queryConditionType:1,table:'chn_userOrder',inputValue:null,_key:'payAmountMax',type:4,
                needAvgDay:0,leftRange:null,rightRange:null,avgDayCondition:0,singleValue:null,singleValue1:null,singleValue2:null,multipleValue:null,needQueryAvgDay:0,unit:'元'}
      ]}

    ]
    return result;


  },
  activityIsForever(stamp){
    if(stamp>=AX_DATE_TIME){
      return "永久";
    }else{
      return this.dateFormat(stamp,'yyyy-MM-dd');
    }
  },
  translateShop(shopId){
    let shopStr="";
    for(let i=0;i<shopId.length;i++){
      switch (shopId[i]){
        case '1':
          shopStr+="杭州 "
          break ;
        case '2':
          shopStr+="濮院 "
          break ;
        case '3':
          shopStr+="温岭 "
          break ;
        case '5':
          shopStr+="广州 "
          break ;
        case '6':
          shopStr+="织里 "
          break ;
        case '7':
          shopStr+="虎门 "
          break ;
        default :
          shopStr+=""
      }

    }
    return shopStr;
  },
  setCookie (name, value, days, otherParams){
  var str = name + '=' + escape(value);
  if(!isNaN(days) && days > 0) str += '; expires=' + new Date().addDate(days).toGMTString();
  if(otherParams && typeof otherParams == 'object') for(var key in otherParams) str += ';' + key + '=' + otherParams[key];
  document.cookie = str;
},
isPassSomeDays(days,longs){
    if(longs==null){
      return true;
    }
    let l=days*24*3600*1000;
    let n=new Date().getTime();
    if((n-l)<=longs){
      return false;
    }else{
      return true;
    }

  },
  dateFormat (date, format) {
    if(date==null||date==undefined){
      return "";
    }
    date = new Date(date);
    var o = {
      'M+': date.getMonth() + 1, //month
      'd+': date.getDate(), //day
      'H+': date.getHours() , //hour+8小时
      'm+': date.getMinutes(), //minute
      's+': date.getSeconds(), //second
      'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
      'S': date.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(format))
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

    for (var k in o)
      if (new RegExp('(' + k + ')').test(format))
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));

    return format;
  },
  dateChange(time,fmt) {
    var date=new Date(time);
    var o = {
      "M+" : date.getMonth()+1, //月份
      "d+" : date.getDate(), //日
      "h+" : date.getHours(), //小时
      "m+" : date.getMinutes(), //分
      "s+" : date.getSeconds(), //秒
      "q+" : Math.floor((date.getMonth()+3)/3), //季度
      "S" : date.getMilliseconds() //毫秒
    };
    if(/(y+)/.test(fmt))
      fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
      if(new RegExp("("+ k +")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
  },
/**
 * 删除Cookie值
 * name: 键
 */
delCookie (name){
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var value = getCookie(name);
  if(value) document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
},

/**
 * 获取指定name的SessionStorage值 name: 键
 */
getSessionStorage (name){
  var obj = window.sessionStorage.getItem(name);
  return obj && (obj.startWith('{') || obj.startWith('[')) ? eval('(' + obj + ')') : obj;
},

/**
 * 设置SessionStorage值 name: 键 value: 值
 */
setSessionStorage (name, value){
  window.sessionStorage.setItem(name, JSON.stringify(value));
},

/**
 * 删除SessionStorage值 name: 键,不传则清楚所有
 */
deleteSessionStorage (name){
  if(name) window.sessionStorage.removeItem(name);
  else window.sessionStorage.clear();
},

/**
 * 获取指定name的localStorage值 name: 键
 */
getLocalStorage (name){
  var obj = window.localStorage.getItem(name);
  return obj && (obj.startWith('{') || obj.startWith('[')) ? eval('(' + obj + ')') : obj;
},

/**
 * 设置localStorage值 name: 键 value: 值
 */
setLocalStorage (name, value){
  window.localStorage.setItem(name, JSON.stringify(value));
},

  // 删除Cookie值 name: 键,不传则清楚所有
deleteLocalStorage (name){
  if(name) window.localStorage.removeItem(name);
  else window.localStorage.clear();
},

  formatAlert(msg){
   return msg.replaceAll("\n", "</br>");
  },

  isArray(obj){
    if(!obj) return false;
    return Object.prototype.toString.call(obj) === '[object Array]';
  },

  /**
   * 深度复制方法
   */
  clone(obj) {
    if (!obj || typeof obj != 'object') return obj;
    var cloneObj;
    if (this.isArray(obj)) {
      cloneObj = [];
      for (var i = 0, len = obj.length; i < len; i++) cloneObj[i] = this.clone(obj[i]);
    } else {
      cloneObj = {};
      for (var key in obj) cloneObj[key] = this.clone(obj[key]);
    }
    return cloneObj;
  },

  toProduct(id){
    window.open(hbtBaseWebUrl+"product-"+id+".html")
  },
  toBrand(id){
    window.open(hbtBaseWebUrl+"brand-"+id+".html")
  },

  tbFormat: {
    date: function (row, column) {
      var date = row[column.property];
      if (date === undefined||date==null) {
        return "";
      }
      return new Date(date).format( 'yyyy-MM-dd');
    },
    time: function (row, column) {
      var date = row[column.property];
      if (date === undefined||date==null) {
        return "-";
      }
      return new Date(date).format( 'yyyy-MM-dd hh:mm:ss');
    },
    timeMin: function (row, column) {
      var date = row[column.property];
      if (date === undefined||date==null) {
        return "-";
      }
      return new Date(date).format( 'yyyy-MM-dd hh:mm');
    },
    toFixed :function(row, column){
      var data =  row[column.property];
      if (data === undefined) {
        return "";
      }
      return Number(data).toFixed(2);
    },
    rateStyle: function (row, column) {
      var data =  row[column.property];
      if (data === undefined) {
        return "";
      }
      return data+"%"
    }
  },

  showImg: function(imgUrl){
    if(!imgUrl || imgUrl.startWith("//") || imgUrl.startWith("http")){
      return imgUrl;
    }
    return hbtBaseImgUrl + imgUrl;
  },

  showNiceImg: function(imgUrl){
    if(imgUrl){
      if(imgUrl.indexOf(".jpeg") != -1){
        var arrUrl = imgUrl.split('.jpeg');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.jpeg";
        }
      }
      if(imgUrl.indexOf(".JPEG") != -1){
        var arrUrl = imgUrl.split('.JPEG');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.JPEG";
        }
      }
      if(imgUrl.indexOf(".jpg") != -1){
        var arrUrl = imgUrl.split('.jpg');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.jpg";
        }
      }
      if(imgUrl.indexOf(".JPG") != -1){
        var arrUrl = imgUrl.split('.JPG');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.JPG";
        }
      }
      if(imgUrl.indexOf(".png") != -1){
        var arrUrl = imgUrl.split('.png');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.png";
        }
      }
      if(imgUrl.indexOf(".PNG") != -1){
        var arrUrl = imgUrl.split('.PNG');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.PNG";
        }
      }
      if(imgUrl.indexOf(".gif") != -1){
        var arrUrl = imgUrl.split('.gif');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.gif";
        }
      }
      if(imgUrl.indexOf(".GIF") != -1){
        var arrUrl = imgUrl.split('.GIF');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.GIF";
        }
      }
      if(imgUrl.indexOf(".tbi") != -1){
        var arrUrl = imgUrl.split('.tbi');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.tbi";
        }
      }
      if(imgUrl.indexOf(".TBI") != -1){
        var arrUrl = imgUrl.split('.TBI');
        if(arrUrl && arrUrl.length > 1){
          imgUrl = arrUrl[0] + "_120x120.TBI";
        }
      }
    }
    if(!imgUrl || imgUrl.startWith("//") || imgUrl.startWith("http")){
      return imgUrl;
    }
    return hbtBaseImgUrl + imgUrl;
  },
  maskString: function (str) {
    if(!str){
      return "";
    }
    if(str.length >= 11){
      return str.substring(0,3) + "****" + str.substring(str.length - 4, str.length)
    }
    return str;
  },

  getDayFromNow: function (d) {
    var miniSec = d.getTime() - new Date().getTime();
    miniSec = Math.abs(miniSec);
    var str = '';
    if(miniSec < 60 * 1000){
      str = '刚刚';
    }else if(miniSec < 1 * 60 * 60 * 1000){
      str = parseInt(miniSec/1000/60) + '分钟前'
    }else if(miniSec <1 * 24 * 60 * 60 * 1000 ){
      str = parseInt(miniSec/1000/60/60) + '小时前'
    }else {
      str = d.format('yyyy-MM-dd');
    }
    return str;
  },
  getDaysFromDate: function (d) {
    var miniSec = d.getTime() - new Date().getTime();
    miniSec = Math.abs(miniSec);
    var str = parseInt(miniSec/1000/60/60/24)+"";
    return str;
  }
}

Element.prototype.hasClass = function(className){
  if(!className || typeof className != 'string') return false;
  return new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);;
};
/**
 * 获取该节点下面所有子节点.
 */
Element.prototype.getChildNodes = function(tag){
  var nodes = this.childNodes;
  var needNodes = [];
  var node = null;
  for(var i = 0, len = nodes.length; i < len; i++){
    node = nodes[i];
    if(node.nodeName != '#text' && node.nodeName != '#comment' &&(!tag || node.tagName.toLowerCase() == tag.toLowerCase())) needNodes.push(node);
  }
  return needNodes;
};

/**
 * 格式日期.
 *  参数为日期格式,默认为yyyy-MM-dd
 */
Date.prototype.format = function(style) {
  if(!style || !(style = style.toString().trim())) style = 'yyyy-MM-dd hh:mm:ss';
  var o = {
    'M+' : this.getMonth() + 1, //month
    'd+' : this.getDate(),      //day
    'h+' : this.getHours(),     //hour
    'm+' : this.getMinutes(),   //minute
    's+' : this.getSeconds(),   //second
    'q+' : Math.floor((this.getMonth() + 3) / 3), //quarter
    'S' : this.getMilliseconds() //millisecond
  };
  if(/(y+)/.test(style)) style = style.replace(RegExp.$1, this.getFullYear().toString().substr(4 - RegExp.$1.length));
  for(var k in o) if(new RegExp('('+ k +')').test(style)) style = style.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(o[k].toString().length));
  return style;
};

/**
 * 获取N天后的时间
 */
Date.prototype.addDate = function(days){
  return new Date(this.valueOf() + days * 24 * 60 * 60 * 1000);
};
/**
 * 批量全部替换
 */
String.prototype.replaceAll = function(s1, s2){
  return this.replace(new RegExp(s1, 'gm'), s2);
};

/**
 * 判断字符串是否以指定字符串开头
 */
String.prototype.startWith = function(compareStr){
  return this.indexOf(compareStr) == 0;
};

/**
 * 判断字符串是否以指定字符串结尾
 */
String.prototype.endWith = function(compareStr){
  return this.length < compareStr.length ? false : this.lastIndexOf(compareStr) == this.length - compareStr.length;
};
/**
 * 获取元素在数组中首次出现的位置.
 */
Array.prototype.indexOf = function(val){
  for (var i = 0, len = this.length; i < len; i++) {
    if (this[i] == val) {
      return i;
    }
  }
  return -1;
};

/**
 * 从数组中删除指定元素
 */
Array.prototype.remove = function(val){
  var index = this.indexOf(val);
  if (index > -1) this.splice(index, 1);
};

/**
 * 遍历集合中所以元素并执行指定操作.
 * 参数为要对集合中元素执行的回调方法.
 */
Array.prototype.foreach = function(fun){
  if(!this.length) return;
  for (var i = 0, len = this.length; i < len; i++) {
    if(typeof fun == 'function')fun.call(this[i], i);
  }
};

//全局常量WEB_SITE
window.hbtBaseImgUrl = "https://img.hznzcn.com/";
window.hbtBaseWebUrl = process.env.WEB_SITE;
window.hbtSearchWebUrl = process.env.SEARCH_SITE;
window.sjfwBaseApi = process.env.API;
window.hbtUploadUrl = process.env.UPLOAD_SITE;
window.hbtUploadNewRms = process.env.UPLOAD_RMS_NEW;
window.hbtUploadOss = process.env.UPLOAD_OSS;
window.hbtVideoUrl = process.env.VIDEO_SITE;
window.hbtErpUrl = process.env.ERP_SITE;
window.AX_DATE_TIME = 1861891200000;



// WEBPACK FOOTER //
// ./src/utils/hbtUtil.js